import React from "react";
import { DateAndTimeGridCell } from "../../common/DateAndTimeGridCell";

const getColumns = () => {
  return [
    {
      field: "compAppUserDetail.userName",
      headerName: "Name",
      flex: 0.75,
      editable: false,
      renderCell: (data) => data?.row?.compAppUserDetail?.userName,
    },
    {
      field: "compAppUserDetail.email",
      headerName: "Email",
      flex: 0.75,
      editable: false,
      renderCell: (data) => data?.row?.compAppUserDetail?.email,
    },
    {
      field: "compAppUserDetail.phoneNumber",
      headerName: "Mobile",
      flex: 0.75,
      editable: false,
      filterable: false,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (data) => data?.row?.compAppUserDetail?.phoneNumber,
    },
    {
      field: "compAppUserDetail.createdAt",
      headerName: "Created At",
      flex: 0.75,
      editable: false,
      type: "dateTime",
      valueGetter: (value) => value ? new Date(value) : null,
      renderCell: (data) => (
        <DateAndTimeGridCell value={data?.row?.compAppUserDetail?.createdAt} />
      ),
    },
  ];
};

export { getColumns };
